export default __webpack_public_path__ + "static/media/bg5.19bd1209.jpg";